import React from "react";
import { Container } from "react-bootstrap";
import Techstack from "./Techstack";

function Stack() {
  return (
    <Container fluid className="about-section">
      <Container>
        <h1 className="project-heading">
          Tech <strong className="red">Stack </strong>
        </h1>
        <p>Technologies and tools we specialize in</p>
        <Techstack />
      </Container>
    </Container>
  );
}

export default Stack;
